/**
 * IMPORTS
 */
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { useMarcarNotificacoes } from "@/hooks/conversa-cliente/use-notificacoes";

import type { INotificacao } from "@/interface/conversa-cliente";

/** Marca como lida (sem bloquear a navegação) e abre o link da notificação. */
function useAbrirNotificacao(aoAbrir?: () => void) {
  const navigate = useNavigate();
  const { marcarLida } = useMarcarNotificacoes();

  return useCallback(
    (notificacao: INotificacao) => {
      if (!notificacao.lida) marcarLida.mutate(notificacao.id);
      aoAbrir?.();
      if (notificacao.link) navigate(notificacao.link);
    },
    [aoAbrir, marcarLida, navigate]
  );
}

/**
 * EXPORTS
 */
export { useAbrirNotificacao };
